__turbopack_context__.v({
  "badge": "ItineraryCardGallery-module__KELAOG__badge",
  "desktopGallery": "ItineraryCardGallery-module__KELAOG__desktopGallery",
  "dot": "ItineraryCardGallery-module__KELAOG__dot",
  "dotActive": "ItineraryCardGallery-module__KELAOG__dotActive",
  "dots": "ItineraryCardGallery-module__KELAOG__dots",
  "gallery": "ItineraryCardGallery-module__KELAOG__gallery",
  "mainImage": "ItineraryCardGallery-module__KELAOG__mainImage",
  "mainImageWrapper": "ItineraryCardGallery-module__KELAOG__mainImageWrapper",
  "modalArrowButton": "ItineraryCardGallery-module__KELAOG__modalArrowButton",
  "modalArrowNext": "ItineraryCardGallery-module__KELAOG__modalArrowNext",
  "modalArrowPrev": "ItineraryCardGallery-module__KELAOG__modalArrowPrev",
  "modalCarousel": "ItineraryCardGallery-module__KELAOG__modalCarousel",
  "modalContent": "ItineraryCardGallery-module__KELAOG__modalContent",
  "modalDot": "ItineraryCardGallery-module__KELAOG__modalDot",
  "modalDotActive": "ItineraryCardGallery-module__KELAOG__modalDotActive",
  "modalDots": "ItineraryCardGallery-module__KELAOG__modalDots",
  "modalScrollTrack": "ItineraryCardGallery-module__KELAOG__modalScrollTrack",
  "modalSlide": "ItineraryCardGallery-module__KELAOG__modalSlide",
  "modalSlideImage": "ItineraryCardGallery-module__KELAOG__modalSlideImage",
  "scrollTrack": "ItineraryCardGallery-module__KELAOG__scrollTrack",
  "slide": "ItineraryCardGallery-module__KELAOG__slide",
  "slideImage": "ItineraryCardGallery-module__KELAOG__slideImage",
  "slider": "ItineraryCardGallery-module__KELAOG__slider",
  "subImage": "ItineraryCardGallery-module__KELAOG__subImage",
  "subImageWrapper": "ItineraryCardGallery-module__KELAOG__subImageWrapper",
  "subImages": "ItineraryCardGallery-module__KELAOG__subImages",
  "tagOverlay": "ItineraryCardGallery-module__KELAOG__tagOverlay",
});
